// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagsPage-module--tags--3gnMS","innerContainer":"TagsPage-module--inner-container--2XLMA","tagsList":"TagsPage-module--tags-list--1o0Vm"};